import { LEADS_COLUMNS } from "features/leads/constants";
import useLeadsDataTable from "features/leads/hooks/useLeadsDataTable";

import {
  ColumnsVisibilityControl,
  DataTable,
} from "common/components/DataTable";
import useColumnVisibility from "common/components/DataTable/useColumnVisibility";
import type { Lead } from "common/types";

import type { ReactNode } from "react";

interface DesktopTableProps {
  leads: Lead[];
  isLoading: boolean;
  pageSize: number;
  totalItemCount: number;
  searchComponent: ReactNode;
}

export default function DesktopTable({
  leads,
  isLoading,
  pageSize,
  totalItemCount,
  searchComponent,
}: DesktopTableProps) {
  //keyed as "leads" so the visible columns stay in sync with the leads page
  const { columnVisibility, setColumnVisibility } = useColumnVisibility(
    "leads",
    LEADS_COLUMNS,
  );

  // leads are only previewed here, so no selection is passed
  const table = useLeadsDataTable({
    leads,
    isLoading,
    pageSize,
    columnVisibility,
    setColumnVisibility,
  });

  return (
    <>
      <div className="flex items-center gap-x-1.5">
        {searchComponent}
        <ColumnsVisibilityControl
          columns={LEADS_COLUMNS}
          columnVisibility={columnVisibility}
          setColumnVisibility={setColumnVisibility}
        />
      </div>

      <DataTable
        table={table}
        totalItemCount={totalItemCount}
        isLoading={isLoading}
      />
    </>
  );
}
